import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#popup',
			dom: {
				close: '.js-popup-close'
			},
			classes: {
				auth: 'popup_state_auth'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	get() {
		this.$close = this.$el.find(this.options.dom.close);
		return this;
	}

	onSet = (event, set) => {
		const self = this;
		self.$el.toggleClass(self.options.classes.auth, set === 'auth');
		self.$el.parent().parent().scrollTop(0);
		self.$window.scrollTop(0);
		setTimeout(function () {
			self.$window.scrollTop(0);
			self.$el.parent().parent().scrollTop(0);
			alert('В этот момент мы просили пользователя ввести свой мобильный телефон.\n Сейчас мы смотрим сайт в демо-режиме, поэтому вы можете ввести ЛЮБЫЕ цифры.');
		}, 150);
	}

	onPopupOpen = () => {
		const self = this;
		self.$el.parent().parent().scrollTop(0);
		self.$window.scrollTop(0);
		setTimeout(function () {
			self.$window.scrollTop(0);
			self.$el.parent().parent().scrollTop(0);
		}, 150);
	}

	onClose = () => {
		const self = this;
		self.$window.trigger('popup.close');
		// setTimeout(function () {
		// 	self.$window
		// 		.trigger('info.clear')
		// 		.trigger('auth.clear')
		// 		.trigger('navigation.setup', ['info']);
		// }, 400);
	}

	init() {
		this.$close.on('click', this.onClose.bind(this));
		this.$window
			.on('navigation.set', this.onSet.bind(this))
			.on('popup.open', this.onPopupOpen.bind(this));
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init();
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/popup/popup.js